exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-106c86ed] .el-table__body-wrapper::-webkit-scrollbar{width:8px;height:auto}", ""]);

// exports
